import React from 'react';
import { hdmiNotSixty } from '../../utils/hdmiMode';

/** The reported HDMI output mode, with a small warning badge when it is not ~60 Hz. */
export default function HdmiMode({ mode }) {
  if (!mode) return <span className="text-text-muted/70">Unknown</span>;
  return (
    <span data-testid="hdmi-mode">
      <code className="text-[11px] text-text-main">{mode}</code>
      {hdmiNotSixty(mode) && (
        <span
          className="ml-2 inline-block rounded px-1.5 py-0.5 text-[10px] font-semibold bg-gold/20 text-gold"
          title="The screen is not driven at 60 Hz"
          data-testid="hdmi-not-60"
        >
          not 60 Hz
        </span>
      )}
    </span>
  );
}
